/** Default ports for each Doss service */
const defaultPorts = {
  web: 3000,
  webAdmin: 4000,
  api: 8080,
  integrations: 8181,
  webhooks: 8282,
  apiAdmin: 8383,
  workflowsRunner: 8585,
  docuforge: 8686,
  systemJobsRunner: 8787,
  workflowSchema: 8888,
  dossbotCodecServer: 8889,

  // Only for health checks
  ['pg-replicator']: 19501,
  ['z-tables-pg-replicator']: 19503,
  workflowsPoolRunner: 8581,
  workflowsRestate: 8583,
  workflowsV2: 8584,
  endpointsRunner: 8586,
  systemJobsPoolRunner: 8783,
  systemJobsFormulasRunner: 8784,
  systemJobsRestate: 8785,
  systemJobsFormulasRestate: 8786,
  clickhouseFlusher: 8985,
  dossbotRuntime: 9090,
} as const

export default defaultPorts
